import axios, { AxiosRequestConfig } from "./axios.service";
import moment from "moment-timezone";
import { headers } from "app/_helpers";
import appConstants from "app/_helpers/app.constants";
import { IBooking, ISchedule, ITableLayout } from "app/app.types";
import { IFilterParameters } from "app/components/Dashboard/types";
import { getUtcDateByVenueTimeZone } from "app/components/Dashboard/helper";

export const bookingsService = {
  getBookings: async (
    filterParameters: IFilterParameters,
    includeCancelledBookings: boolean
  ): Promise<IBooking[]> => {
    try {
      console.log(`call to bookingsService.getBookings`);
      const reqConfig: AxiosRequestConfig = {
        headers: {
          ...headers.defaultHeaders(),
          ...headers.backendApiKeyHeader,
        },
      };

      const selectedVenueTimeZoneId = filterParameters.selectedVenue.timeZoneId;
      const startDateAsUtc = getUtcDateByVenueTimeZone(
        selectedVenueTimeZoneId,
        filterParameters.fromDate
      );
      const endDateAsUtc = getUtcDateByVenueTimeZone(
        selectedVenueTimeZoneId,
        filterParameters.toDate
      );
      const url = `${appConstants.iPosServiceUrl}/internal/venues/${filterParameters.selectedVenue.id}/reports/bookings?startDate=${startDateAsUtc}&endDate=${endDateAsUtc}&includeCustomerDetails=true&allowWalkins=false&includeCancelledBookings=${includeCancelledBookings}`;
      const result = await axios.get<IBooking[]>(url, reqConfig);
      return result.data;
    } catch (error) {
      console.warn(
        `call to bookingsService.getBookings for venue ${filterParameters.selectedVenue.id} failed to load. ${error}`
      );
    }
    return [] as IBooking[];
  },
  getTables: async (
    filterParameters: IFilterParameters
  ): Promise<ITableLayout[]> => {
    try {
      console.log(`call to bookingsService.getTables`);
      const reqConfig: AxiosRequestConfig = {
        headers: {
          ...headers.defaultHeaders(),
          ...headers.backendApiKeyHeader,
        },
      };

      const url = `${appConstants.iPosServiceUrl}/internal/venues/${filterParameters.selectedVenue.id}/reports/tables?Date=${filterParameters.serviceGroupingPaxCountDate}`;
      const result = await axios.get<ITableLayout[]>(url, reqConfig);
      return result.data;
    } catch (error) {
      console.warn(
        `call to bookingsService.getTables for venue ${filterParameters.selectedVenue.id} failed to load. ${error}`
      );
    }
    return [] as ITableLayout[];
  },
  getSchedule: async (
    filterParameters: IFilterParameters
  ): Promise<ISchedule> => {
    try {
      console.log(`call to bookingsService.getSchedule`);
      const reqConfig: AxiosRequestConfig = {
        headers: {
          ...headers.defaultHeaders(),
          ...headers.backendApiKeyHeader,
        },
      };

      const url = `${appConstants.iPosServiceUrl}/internal/venues/${filterParameters.selectedVenue.id}/reports/schedule?BookingDateTimeStart=${filterParameters.serviceGroupingPaxCountDate}&NumOfPeople=0`;
      const result = await axios.get<ISchedule>(url, reqConfig);
      return result.data;
    } catch (error) {
      console.warn(
        `call to bookingsService.getSchedule for venue ${filterParameters.selectedVenue.id} failed to load. ${error}`
      );
    }
    return null;
  },
};
